import { Heart } from 'lucide-react';

export function TributeFooter() {
  return (
    <div className="fixed bottom-0 left-0 right-0 h-4 bg-black border-t border-gray-800 flex items-center justify-center text-xs text-gray-400 z-50">
      <div className="flex items-center gap-1.5">
        <span>Project Acacia DEX by</span>

        {/* Zerocap Mini Hexagon */}
        <svg
          width="12"
          height="12"
          viewBox="0 0 56 64"
          className="inline-block"
          style={{ transform: 'rotate(30deg)' }}
        >
          <g>
            <polygon points="7.6 20.4 7.6 43.8 27.9 55.5 48.1 43.8 48.1 20.4 27.9 8.7" fill="currentColor" opacity="0.3" />
            <polygon points="48.1 20.4 48.1 43.8 27.9 55.5 7.6 43.8 7.6 20.4 0 16 0 48.2 27.9 64.3 55.7 48.2 55.7 16" fill="#F16152" />
            <polygon points="27.9 8.7 48.1 20.4 55.7 16 27.9 0 0 16 7.6 20.4" fill="#A83031" />
          </g>
        </svg>

        <span>Zerocap</span>

        <Heart className="w-3 h-3 fill-current text-red-500" />

        {/* Ripple Logo */}
        <img
          src="/ripple-logo.svg"
          alt="Ripple"
          className="h-3 inline-block"
        />

        <Heart className="w-3 h-3 fill-current text-red-500" />

        {/* Chainlink Logo */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="14"
          viewBox="0 0 56 65"
          fill="none"
          className="inline-block"
        >
          <path d="M27.92 0L0 16.25V48.75L27.92 65L55.8401 48.75V16.25L27.92 0ZM44.0118 41.8626L27.9252 51.2252L11.8386 41.8626V23.1374L27.9252 13.7748L44.0118 23.1374V41.8626Z" fill="#0847F7" />
        </svg>

        <span className="text-[#0847F7]">Chainlink</span>
      </div>
    </div>
  );
}
